import { useEffect, useState } from "react";
type Theme="light"|"dark";
export function useTheme(){
  const [theme,setTheme]=useState<Theme>(()=>(localStorage.getItem("sa-theme") as Theme|null)??(matchMedia("(prefers-color-scheme: dark)").matches?"dark":"light"));
  useEffect(()=>{document.documentElement.classList.toggle("dark",theme==="dark");document.documentElement.style.colorScheme=theme;document.querySelector('meta[name="theme-color"]')?.setAttribute("content",theme==="dark"?"#34368f":"#5558da");localStorage.setItem("sa-theme",theme)},[theme]);
  return {theme,toggle:()=>setTheme(v=>v==="dark"?"light":"dark")};
}
